import axios from "../../axios/index.js"

export default {
  listeaideclients(username) {
    return axios.get("aideclients/my/"+username,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  deleteaideclient(itemId) {
    
   return axios.delete("aideclients/"+itemId,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  addaideclient(username,item)
  {
  return axios.post("aideclients/"+username,{nom: item.nom, prenom: item.prenom, email: item.email, role: item.role},{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
   }
   ,
   listeCommandesEncours(id) {
    
    //return axios.get("commandes/commandes/"+id,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
    return axios.get("commandes/my/"+id,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  livreurPosActuelle(id) {
    
    return axios.get("positionsgps/"+id,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  getAllPositions(magasin){
    return axios.get("positionsgps/magasin/"+magasin,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  }
  
}
